import { render, staticRenderFns } from "./StatusDialogOrderCard.vue?vue&type=template&id=0df5b064"
import script from "./StatusDialogOrderCard.vue?vue&type=script&lang=js"
export * from "./StatusDialogOrderCard.vue?vue&type=script&lang=js"
import style0 from "./StatusDialogOrderCard.vue?vue&type=style&index=0&id=0df5b064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports